// Company Assets — served via the fridge.com/company-logos/* proxy (next.config
// rewrite → Supabase Storage). Site-relative so the browser and RSC payload only
// ever show a fridge.com URL, never a *.supabase.co host (owner directive 07/20).
// Used only as on-page <Image> srcs; the optimizer fetches them same-origin.
export const COMPANY_LOGO_BLUE = '/company-logos/Fridge.com-blue.png'
export const COMPANY_LOGO_WHITE = '/company-logos/Fridge.com-logo-white-transparent.png'

// Fallback image for blog articles (logo -- used in blog index thumbnails, hub pages)
export const BLOG_FALLBACK_IMAGE = COMPANY_LOGO_BLUE

// Fallback hero image for blog posts with no article image (1200x628, logo centered on white bg)
export const BLOG_HERO_FALLBACK = 'https://fridge.com/blog-images/fallback-blog-hero.png'

// Fridge.com Brand Colors
export const BRAND_COLORS = {
  white: '#ffffff',
  orange: '#ff9951',
  bluePrimary: '#0469f0',
  blueDark: '#004aad',
} as const

